<template>
  <div>
    <ModuleHeader>Cobro a meseros y Pago de propina (BOKKA)</ModuleHeader>
    <p>
      Solo se sumarizan propinas en Pesos Mexicanos, las propinas en dolares son
      informativas
    </p>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-alert v-if="$store.getters.getFirebaseApp.tenant != 'BOKA'" type="error">
      Modulo no disponible para este campo
    </v-alert>
    <v-row v-if="$store.getters.getFirebaseApp.tenant == 'BOKA'">
      <v-col cols="12" md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field @input="getAperturas()" v-model="input_date" label="Fecha Inicial"
                      prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date" @input="
                    menuFechaInicial = false;
                  getAperturas();
                  "></v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-if="true" cols="12" md="2">
                <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar" readonly
                      @input="getAperturas()" v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date_final" @input="
                    menuFechaInicial2 = false;
                  getAperturas();
                  "></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="12" cols="12">
                <v-autocomplete label="Departamentos" @input="getAperturas()" v-model="selectDep" item-text="Nombre"
                  item-value="id" :items="departamentos"></v-autocomplete>
              </v-col>
              <v-col cols="12" md="12">
                <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                  :items="turnosList">
                  <template v-slot:append-outer>
                    <v-btn @click="getAperturas()" small color="primary">Buscar turnos</v-btn>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col md="2" cols="12">
                <v-autocomplete label="Meseros" v-model="selectMesero" item-text="Nombre" item-value="id"
                  :items="meserosComp" multiple @change="handleSelectChange"></v-autocomplete>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field label="Porcentaje" v-model="porcentaje"></v-text-field>
              </v-col>
              <v-col md="3" cols="12">
                <v-text-field v-if="false" v-model="input_folio" label="Folio de Venta"></v-text-field>
              </v-col>
              <v-col v-if="false" md="3">
                <v-switch v-model="render" @change="datos = { processedData: [], all: [] }"
                  :label="`Mostrar Resultados`"></v-switch>
              </v-col>
              <v-col class="text-right mt-n5" md="12">
                <v-btn v-if="datos.processedDataMesero.length > 0" depressed @click="generatePdf()" color="red" dark>
                  PDF
                </v-btn>
                <v-btn depressed @click="searchVentas()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card elevation="0">
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Mesero</th>
                  <th>Fecha</th>
                  <th>Folio</th>
                  <th>Total</th>
                  <th>{{ porcentaje }}%</th>
                  <th>Propinas</th>
                  <th>Pago</th>
                  <th>Estadistica</th>
                  <th>Detalle</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(venta, index) in datos.processedDataMesero">
                  <tr v-if="venta.tipo == 'header'" style="background: #2185d03b" :key="index">
                    <td style="height: 18px" colspan="9">
                      <b>{{ venta.Mesero }}</b>
                    </td>
                  </tr>
                  <tr v-if="venta.tipo == 'venta'" :key="index">
                    <td>
                      {{ venta.Mesero ? venta.Mesero.Nombre : "SIN MESERO" }}
                    </td>
                    <td>{{ venta.FechaVenta }}</td>
                    <td>{{ venta.Folio }}</td>
                    <td>${{ $pgsHelper.formatNumber(venta.TotalVenta) }}</td>
                    <td>
                      ${{
                        $pgsHelper.formatNumber(
                          (venta.TotalVenta * Number(porcentaje)) / 100
                        )
                      }}
                    </td>
                    <td>
                      ${{ $pgsHelper.formatNumber(venta.TotalesPropina.MXN)
                      }}<br />
                      {{
                        venta.TotalesPropina.USD != 0
                          ? "USD $" +
                          $pgsHelper.formatNumber(venta.TotalesPropina.USD)
                          : ""
                      }}
                    </td>
                    <td></td>
                    <td>
                      Pago Tarjetas:
                      {{ $pgsHelper.formatNumber(venta.TotalPagoTarjeta) }}
                      <br />
                      Propinas Tarjetas:
                      {{
                        $pgsHelper.formatNumber(venta.TotalPropinaTarjeta.MXN)
                      }}
                      <br />
                      Porcentaje:
                      {{
                        venta.TotalPagoTarjeta > 0
                          ? $pgsHelper.formatNumber(
                            (venta.TotalPropinaTarjeta.MXN * 100) /
                            venta.TotalPagoTarjeta
                          )
                          : 0
                      }}
                      %
                    </td>
                    <td>
                      <v-btn @click="showDetail(venta)" small elevation="1" color="primary">DETALLE</v-btn>
                    </td>
                  </tr>
                  <tr v-if="venta.tipo == 'footer'" style="background: #a9a9a969" :key="index">
                    <td style="height: 15px" colspan="3"><b>TOTAL:</b></td>
                    <td style="height: 15px">
                      <b>${{ $pgsHelper.formatNumber(venta.Total) }}</b>
                    </td>
                    <td style="height: 15px">
                      <b>${{
                        $pgsHelper.formatNumber(
                          (venta.Total * Number(porcentaje)) / 100
                        )
                      }}</b>
                    </td>
                    <td style="height: 15px">
                      <b>${{
                        $pgsHelper.formatNumber(venta.TotalPropinaMesero)
                      }}
                        <br />
                        {{
                          venta.TotalPropinaUSD != 0
                            ? "USD $" +
                            $pgsHelper.formatNumber(venta.TotalPropinaUSD)
                            : ""
                        }}
                      </b>
                    </td>
                    <td style="height: 15px">
                      <b>
                        ${{
                          $pgsHelper.formatNumber(
                            venta.TotalPropinaMesero -
                            (venta.Total * Number(porcentaje)) / 100
                          )
                        }}
                      </b>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<style scoped></style>

<script>
import "../../../assets/css/sideBar.css";
import Cliente from "../../../clases/Cliente.js";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
import Membresia from "../../../clases/Membresias/Membresia.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteMeseros from "../../../clases/PdfMakers/RepoPagoMeseros.js";
import Vue from "vue";
import resumenVenta from "../../MainComponents/resumenVenta.vue";
import { mapActions } from "vuex";

export default {
  name: "ReporteGeneral",
  components: {
    /*Select2,*/
    resumenVenta,
  },
  props: ["hideMenu"],
  data() {
    return {
      selectTurno: "ALL",
      aperturas: [],
      porcentaje: 0,
      meseros: [],
      selectDep: "ALL",
      currencyClass: Currency,
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      render: true,
      selectMesero: ["ALL"],
      datos: {
        all: [],
        processedData: [],
        processedDataMesero: [],
      },
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      Categories: [],
      familias: [],
      header: [
        "Cliente",
        "Membresia",
        "Folio",
        "Familia",
        "Categoría",
        "Descripción",
        "Cantidad",
        "Total",
        "Método de pago",
        "Autorización",
        "Total",
        "Impuestos",
      ],
      processedData: [],
    };
  },
  computed: {
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    Membresias() {
      return this.$pgsHelper.indexBy(Membresia.getMembresiasList(), "Id");
    },
    selectedReserva() {
      return this.selectedRes;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = this.$pgsHelper.indexBy(Cliente.getClientsList(), "Id");
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto(), ...cli });
      });
      return clientes;
    },
    comp_totales() {
      let total = {
        Cantidad: 0,
        Descuento: 0,
        Monto: 0,
        Subtotal: 0,
        Impuestos: 0,
      };
      this.datos.processedData.forEach((prod) => {
        total.Cantidad += Number(prod.Cantidad);
        let totalMonto = Number(prod.Subtotal) + Number(prod.Impuestos);
        total.Monto += Number(totalMonto);
        total.Descuento += Number(prod.Descuento);
        total.Subtotal += Number(prod.Subtotal);
        total.Impuestos += Number(prod.Impuestos);
      });
      return total;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    meserosComp() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.meseros;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
  },
  methods: {
    handleSelectChange() {
      if (
        this.selectMesero.includes("ALL") &&
        this.selectMesero.some((item) => item !== "ALL")
      ) {
        // Si "ALL" está seleccionado junto con otros, elimina "ALL" y deja los otros
        let lengthSelected = this.selectMesero.length;
        if (this.selectMesero[lengthSelected - 1] == "ALL") {
          this.selectMesero = ["ALL"];
        } else {
          this.selectMesero = this.selectMesero.filter(
            (item) => item !== "ALL"
          );
        }
      }
    },

    async getAperturas() {
      const startDate = this.input_date;
      const endDate = this.input_date_final;
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = "";
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date,
        FF: this.input_date_final,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        Departamento: this.selectDep,
        processedDataMesero: this.datos.processedDataMesero,
        porcentaje: this.porcentaje,
      };
      let docData = ReporteMeseros.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    processVentasMesero() {
      let dataVentas = [];
      this.datos.all.forEach((venta) => {
        let mesero = "";

        for (const property in venta.Catalogo) {
          mesero = venta.Catalogo[property].ExtraParams?.AYB?.Mesero;
        }
        let totalVenta = 0;
        let totalPagoTarjeta = 0;
        venta.TotalPagoTarjeta = 0;
        venta.Catalogo.forEach((prod) => {
          try {
            Object.entries(prod.Pagos).forEach((pago) => {
              totalVenta += pago[1].def.C;
            });
          } catch (e) {
            console.log(e);
          }
        });

        if (venta.Pagos) {
          let pagos = Object.entries(venta.Pagos);
          pagos.forEach((pago) => {
            let keysPago = pago[0].split("_");
            if (
              keysPago[1] == "MXN" &&
              (keysPago[0] == "MACA" ||
                keysPago[0] == "VISA" ||
                keysPago[0] == "AMEX")
            ) {
              totalPagoTarjeta += Number(pago[1].Cantidad);
            }
          });
        }

        let TotalPropina = { MXN: 0, USD: 0 };
        let TotalPropinaTarjeta = { MXN: 0, USD: 0 };

        if (venta.Props) {
          let propinas = Object.entries(venta.Props);
          propinas.forEach((prop) => {
            let keysProps = prop[0].split("_");
            if (keysProps[1] == "MXN") {
              TotalPropina.MXN += Number(prop[1].Cantidad);
              if (
                keysProps[0] == "MACA" ||
                keysProps[0] == "VISA" ||
                keysProps[0] == "AMEX"
              ) {
                TotalPropinaTarjeta.MXN += Number(prop[1].Cantidad);
                venta.TotalPagoTarjeta = totalVenta;
              }
            } else if (keysProps[1] == "USD") {
              TotalPropina.USD += Number(prop[1].Cantidad);
            }
          });
        }
        //venta.TotalPagoTarjeta = totalVenta//totalPagoTarjeta
        venta.TotalPropinaTarjeta = TotalPropinaTarjeta;
        venta.TotalesPropina = TotalPropina;
        venta.TotalVenta = totalVenta;
        venta.Mesero = this.$pgsHelper.getById(this.meseros, "id", mesero);
        venta.MeseroId = venta.Mesero ? venta.Mesero.id : "SIN MESERO";
        if (this.selectMesero == "ALL") {
          dataVentas.push(venta);
        } else if (this.selectMesero.includes(venta.MeseroId)) {
          dataVentas.push(venta);
        }
      });

      dataVentas.sort((a, b) => {
        const nameA = a.Mesero ? a.Mesero.id : "SIN MESERO"; // ignore upper and lowercase
        const nameB = b.Mesero ? b.Mesero.id : "SIN MESERO"; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
      let dataGrouped = [];
      let Mesero = "";
      let totalMesero = 0;
      let totalPropinaMesero = 0;
      let totalPagoTarjetas = 0;
      let totalPropinasTarjetas = 0;
      let totalPropinaMeseroUSD = 0;
      dataVentas.forEach((venta, index) => {
        if (venta.MeseroId != Mesero) {
          dataGrouped.push({
            tipo: "header",
            Mesero: venta.Mesero ? venta.Mesero.Nombre : "SIN MESERO",
          });
          totalMesero = 0;
          totalPropinaMesero = 0;
          totalPropinaMeseroUSD = 0;
          totalPagoTarjetas = 0;
          totalPropinasTarjetas = 0;
        }

        dataGrouped.push({ tipo: "venta", ...venta });
        totalMesero += venta.TotalVenta;
        totalPropinaMesero += venta.TotalesPropina.MXN;
        totalPropinaMeseroUSD += venta.TotalesPropina.USD;
        totalPagoTarjetas += venta.TotalPagoTarjeta;
        totalPropinasTarjetas += venta.TotalPropinaTarjeta.MXN;
        if (dataVentas[index + 1]) {
          if (venta.MeseroId != dataVentas[index + 1].MeseroId) {
            dataGrouped.push({
              tipo: "footer",
              Mesero: venta.Mesero ? venta.Mesero.Nombre : "SIN MESERO",
              Total: totalMesero,
              TotalPropinaMesero: totalPropinaMesero,
              TotalPropinaUSD: totalPropinaMeseroUSD,
              TotalPropinasTarjetas: totalPropinasTarjetas,
              TotalPagoTarjetas: totalPagoTarjetas,
            });
          }
        } else {
          dataGrouped.push({
            tipo: "footer",
            Mesero: venta.Mesero ? venta.Mesero.Nombre : "SIN MESERO",
            Total: totalMesero,
            TotalPropinaMesero: totalPropinaMesero,
            TotalPropinaUSD: totalPropinaMeseroUSD,
            TotalPropinasTarjetas: totalPropinasTarjetas,
            TotalPagoTarjetas: totalPagoTarjetas,
          });
        }

        Mesero = venta.MeseroId;
      });
      this.datos.processedDataMesero = dataGrouped;
    },
    async getMeserosAB() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "AYB/Meseros"
      );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
    processVentas() {
      console.time("ProcessVentas");
      let productosVenta = [];
      this.datos.all.forEach((el) => {
        let pagos = Object.entries(el.Pagos);
        const map = new Map();
        let client = this.$pgsHelper.searchIndex(
          this.comp_clients,
          "Id",
          el.Cliente.Id
        );
        /*let idMembresia = client.ExtraData?.Membresia?.Membresia;
          let Membresia = this.$pgsHelper.searchIndex(
            this.Membresias,
            "Id",
            idMembresia
          );*/
        el.Catalogo.forEach((prod) => {
          try {
            Object.entries(prod.Pagos).forEach((pago) => {
              let noGrava = false;
              if (
                prod.Nombre.includes("Nueva Membresia") ||
                prod.Nombre.includes("Cuota Extraordinaria")
              ) {
                noGrava = true;
              }
              let iva = prod.Iva / 100 + 1;
              let imp = !noGrava
                ? parseFloat(pago[1].def.C - pago[1].def.C / iva).toFixed(2)
                : 0;
              let st = !noGrava
                ? parseFloat(pago[1].def.C - imp).toFixed(2)
                : parseFloat(pago[1].def.C).toFixed(2);
              let producto = {
                Fecha: el.FechaVenta,
                Cliente: el.Cliente.Nombre,
                Apodo: el.Cliente.Apodo ? " - " + el.Cliente.Apodo : "",
                /*Membresia: Membresia
                    ? Membresia?.Code?.Pre + "-" + Membresia?.Code?.Pos
                    : "N/A",*/
                Folio: el.Folio,
                Departamento: el.Departamento,
                ClaveSAT: prod.Familia ? prod.Familia.C : "-",
                Familia: prod.Familia ? prod.Familia.N : "-",
                Categoria: prod.Categoria ? prod.Categoria.N : "-",
                Producto: prod.Nombre,
                Mesero: prod.ExtraParams?.AYB?.Mesero,
                Cantidad: pago[0] ? parseFloat(pago[1].cnt).toFixed(2) : "",
                Monto: pago[1].rel.C,
                Moneda: pago[1].rel.M,
                TipoPago: pago[0] ? pago[1].name : "",
                Descuento: pago[1].dsc
                  ? parseFloat(pago[1].dsc.C).toFixed(2)
                  : "-",
                Autorizacion: pago[0] ? pago[1].code : "",
                //Impuestos:((pago[1].def.C/100)*16),
                Subtotal: st,
                Impuestos: imp,
              };
              if (prod.ExtraParams?.AYB?.Mesero) {
                productosVenta.push(producto);
              }
            });
          } catch (e) {
            console.log(el.Folio);
          }
        });
      });
      this.datos.processedData = productosVenta;
      console.timeEnd("ProcessVentas");
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.input_folio = "";
      this.selectClient = "";
      this.selectDep = "ALL";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async getCajas() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajas"
      );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Cajeros"
      );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }

      let listVentas = [];
      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          /*firestore.where("FechaVenta", ">=", startDate),
            firestore.where("FechaVenta", "<", end),*/
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        if (this.selectDep != "ALL") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }

        filter.push(firestore.where("Turno", "==", id));

        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
      });

      await Promise.all(taskTurnos).then((turnos) => {
        let preData = this.$_.orderBy(listVentas, "fecha", "desc");
        this.datos.all = preData;
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    async getFamilias() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Productos/Familias"
      );

      this.familias = [];
      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    searchVentas() {
      Promise.resolve()
        .then(() => {
          this.loadingData = true;
        })
        .then(() => {
          return this.getVentas();
        })
        .then(() => {
          this.loadingData = false;
        })
        .then(() => {
          return this.$nextTick();
        })
        .then(() => {
          //this.processVentas();
          this.processVentasMesero();
        });
    },
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    await this.getAperturas();
    this.getCategories();
    this.getFamilias();
    this.getCajas();
    this.getMeserosAB();
    this.getCashiers();
    this.$emit("useNav", true);
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
